import React from 'react'

const TroubleshooterSimulationGraph = () => (
    <canvas id="diagnosisChart" className="mt-5" width="600" height="600"></canvas>
)

export default TroubleshooterSimulationGraph